import React, { useState, useEffect } from 'react';
import { staffAPI } from '../../services/api';
import DataTable from '../../components/common/DataTable';
import StatusBadge from '../../components/common/StatusBadge';
import Modal from '../../components/common/Modal';
import toast from 'react-hot-toast';
import { formatDate } from '../../utils/helpers';

const StaffLeaves = () => {
  const [leaves, setLeaves] = useState([]);
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState({ status: '' });
  const [form, setForm] = useState({ staff: '', leave_type: 'casual', from_date: '', to_date: '', days: 1, reason: '' });

  useEffect(() => {
    setLoading(true);
    Promise.allSettled([
      staffAPI.leaves(filter),
      staffAPI.list({ page_size: 100 }),
    ]).then(([lRes, sRes]) => {
      if (lRes.status === 'fulfilled') setLeaves(lRes.value.data.results || lRes.value.data);
      if (sRes.status === 'fulfilled') setStaff(sRes.value.data.results || sRes.value.data);
    }).finally(() => setLoading(false));
  }, [filter]);

  const handleApprove = async (id, status) => {
    try {
      await staffAPI.updateLeave(id, { status });
      toast.success(`Leave ${status}`);
      setLeaves(leaves.map(l => l.id === id ? { ...l, status } : l));
    } catch { toast.error('Failed to update'); }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      await staffAPI.createLeave(form);
      toast.success('Leave applied!');
      setShowModal(false);
      setForm({ staff: '', leave_type: 'casual', from_date: '', to_date: '', days: 1, reason: '' });
      staffAPI.leaves(filter).then(r => setLeaves(r.data.results || r.data));
    } catch { toast.error('Failed to apply leave'); }
  };

  const columns = [
    { key: 'staff_name', label: 'Staff', render: v => <strong>{v}</strong> },
    { key: 'leave_type', label: 'Type', render: v => <span className="badge bg-info text-dark">{v}</span> },
    { key: 'from_date', label: 'From', render: v => formatDate(v) },
    { key: 'to_date', label: 'To', render: v => formatDate(v) },
    { key: 'days', label: 'Days' },
    { key: 'reason', label: 'Reason', render: v => v?.length > 40 ? v.slice(0, 40) + '...' : v },
    { key: 'status', label: 'Status', render: v => <StatusBadge status={v} /> },
    { key: 'id', label: 'Actions', render: (id, row) => row.status === 'pending' ? (
      <div className="d-flex gap-1">
        <button className="btn btn-sm btn-success" onClick={() => handleApprove(id, 'approved')}>✅</button>
        <button className="btn btn-sm btn-danger" onClick={() => handleApprove(id, 'rejected')}>❌</button>
      </div>
    ) : null },
  ];

  return (
    <div>
      <div className="page-header">
        <div><h2>Staff Leave Management</h2> </div>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>➕ Apply Leave</button>
      </div>
      <div className="card mb-3"><div className="card-body">
        <select className="form-select w-auto" value={filter.status} onChange={e => setFilter({...filter, status: e.target.value})}>
          <option value="">All Status</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>
      </div></div>
      <div className="card">
        <div className="card-header"><span>📋 Leave Requests ({leaves.length})</span></div>
        <DataTable columns={columns} data={leaves} loading={loading} />
      </div>
      <Modal show={showModal} onClose={() => setShowModal(false)} title="Apply for Leave">
        <form onSubmit={handleSave}>
          <div className="mb-3"><label className="form-label">Staff Member *</label>
            <select className="form-select" value={form.staff} onChange={e => setForm({...form, staff: e.target.value})} required>
              <option value="">Select Staff</option>
              {staff.map(s => <option key={s.id} value={s.id}>{s.full_name || `${s.first_name} ${s.last_name}`}</option>)}
            </select>
          </div>
          <div className="mb-3"><label className="form-label">Leave Type *</label>
            <select className="form-select" value={form.leave_type} onChange={e => setForm({...form, leave_type: e.target.value})}>
              <option value="casual">Casual</option><option value="sick">Sick</option>
              <option value="earned">Earned</option><option value="maternity">Maternity</option><option value="other">Other</option>
            </select>
          </div>
          <div className="row">
            <div className="col-6 mb-3"><label className="form-label">From Date *</label><input type="date" className="form-control" value={form.from_date} onChange={e => setForm({...form, from_date: e.target.value})} required /></div>
            <div className="col-6 mb-3"><label className="form-label">To Date *</label><input type="date" className="form-control" value={form.to_date} onChange={e => setForm({...form, to_date: e.target.value})} required /></div>
            <div className="col-6 mb-3"><label className="form-label">Number of Days *</label><input type="number" className="form-control" value={form.days} onChange={e => setForm({...form, days: e.target.value})} required /></div>
          </div>
          <div className="mb-3"><label className="form-label">Reason *</label><textarea className="form-control" rows={3} value={form.reason} onChange={e => setForm({...form, reason: e.target.value})} required /></div>
          <div className="d-flex gap-2 justify-content-end">
            <button type="button" className="btn btn-outline-secondary" onClick={() => setShowModal(false)}>Cancel</button>
            <button type="submit" className="btn btn-primary">📤 Apply Leave</button>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default StaffLeaves;
